import { Application } from '@/types/application';
import { ComparerScopedVariable, ComparerVariables } from '@/types/comparer';
import { Variable } from '@/types/variable';

const addVariables = (variablesA: Variable[], variablesB: Variable[]): ComparerScopedVariable[] => {
  const result: ComparerScopedVariable[] = [];
  const mapA = new Map(variablesA.map((variable) => [variable.name, variable]));
  const mapB = new Map(variablesB.map((variable) => [variable.name, variable]));
  const allIds = new Set([...mapA.keys(), ...mapB.keys()]);

  allIds.forEach((id) => {
    const varA = mapA.get(id);
    const varB = mapB.get(id);
    if (!varA) result.push({ status: 'added', id: varB?.name || '', newType: varB?.type });
    else if (!varB) result.push({ status: 'removed', id: varA?.name, oldType: varA?.type });
    else
      result.push({
        status: varA.type !== varB.type ? 'modified' : 'unchanged',
        id: varA.name,
        oldType: varA.type,
        newType: varB.type
      });
  });

  return result;
};

export const compareVariables = (appA: Application, appB: Application): ComparerVariables => {
  const result: ComparerVariables = {
    config: [],
    global: [],
    task: [],
    channel: [],
    session: [],
    local: {}
  };
  const scopes = ['config', 'global', 'task', 'session', 'channel'] as const;

  scopes.forEach((scope) => {
    result[scope] = addVariables(appA.variables[scope] ?? [], appB.variables[scope] ?? []);
  });

  const localVariablesA = appA.variables.local ?? {};
  const localVariablesB = appB.variables.local ?? {};
  const allSubIds = new Set([...Object.keys(localVariablesA), ...Object.keys(localVariablesB)].map(Number));

  allSubIds.forEach((subId) => {
    result.local[subId] = addVariables(localVariablesA[subId] ?? [], localVariablesB[subId] ?? []);
  });

  return result;
};
